import React, { useState } from 'react'
import OrdenoLogo from '../Login/img-login/ordeno-logo.png'
import ApiService from '../../../services/ApiService'
import { ErrContainer } from '../MainBox/style'

import {
  FullPageWrapper,
  Box,
  Logo,
  Title,
  Subtitle,
  FormGroup,
  FieldLabel,
  InputField,
  SubmitButton,
  BackRow,
  BackIcon,
  BackText,
} from './style'

interface PassResetEmailProps {
  setPage: (page: string) => void
}

const PassResetEmail: React.FC<PassResetEmailProps> = ({ setPage }) => {
  const [email, setEmail] = useState<string>('')
  const [errStatus, setErrStatus] = useState<number>(0)

  const handleSubmit = async () => {
    try {
      await ApiService.auth.resetPassword(email)
      setErrStatus(0)
      localStorage.setItem('resetEmail', email)
      setPage('CodeInput')
    } catch (err) {
      console.log(err)
      setErrStatus(500)
    }
  }

  return (
    <FullPageWrapper>
      <Box>
        {/* Logo ordeno */}
        <Logo src={OrdenoLogo} alt='ordeno' />

        {/* Título */}
        <Title>Esqueceu sua senha?</Title>

        {/* Subtítulo */}
        <Subtitle>
          Um código será enviado para o seu email para te ajudar a redefinir sua
          senha.
        </Subtitle>

        {/* Campo email */}
        <FormGroup>
          <FieldLabel htmlFor='email'>Email</FieldLabel>

          <InputField
            id='email'
            type='text'
            placeholder='Digite aqui'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {errStatus === 500 ? (
            <ErrContainer>Email inválido</ErrContainer>
          ) : null}
        </FormGroup>

        {/* Botão principal */}
        <SubmitButton type='button' onClick={handleSubmit}>
          Redefinir senha
        </SubmitButton>

        {/* Voltar */}
        <BackRow onClick={() => setPage('Main')}>
          <BackIcon>←</BackIcon>
          <BackText>Voltar ao login</BackText>
        </BackRow>
      </Box>
    </FullPageWrapper>
  )
}

export default PassResetEmail
